import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import {
    BoxContainer,
    Underline,
    BoxTitle,
    BoxHead,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import SearchFilterBox from "../../Components/SearchFilterBox";
import Table from "../../Components/Deal/Table";
import SideModal from "../../Components/SideModal";
import FilterModal from "../../Components/Deal/FilterModal";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SummaryCards from "../../Components/Deal/SummaryCard";
import EditDeal from "../../Components/Deal/EditDeal";
import EditBasicInfo from "../../Components/Deal/EditBasicInfo";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import Loading from "../../Components/Loading";
import Notes from "../../Components/Deal/Note";
import moment from "moment";
import DateRange from "../../Components/DateRange";

const Deal = () => {
    const user = useSelector((state) => state.UserReducer.user);

    const [activeFilter, setActiveFilter] = useState({
        value: "",
        label: "",
        title: "",
    });
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const searchOptions = [{ label: "Name", value: 1 }];
    const [selectedData, setSelectedData] = useState("");
    const [selectedId, setSelectedId] = useState(null);
    const [isFocused, setIsFocused] = useState(false);
    const [isEditDeal, setIsEditDeal] = useState(false);
    const [isEditBasicInfo, setIsEditBasicInfo] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [activeTab, setActiveTab] = useState("1");
    const [summaryData, setSummaryData] = useState(null);
    const [isViewNotes, setIsViewNotes] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setFilterType] = useState("");

    //--Date filter---
    const [startDate, setStartDate] = useState(
        moment().startOf("month").format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        moment().endOf("month").format("YYYY-MM-DD")
    );

    // Track if filter is applied
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const getFilterType = (type) => {
        switch (type) {
            case 1:
                return "NAME";
            default:
                return "";
        }
    };

    const fetchDealList = async (params) => {
        const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}&startDate=${params.startDate || ""}&endDate=${params.endDate || ""}`;
        const response = await axios.get(
            `${Config.apiUrl}/deal/list?${query}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    const getDealSuccess = (res) => {
        if (res?.isSuccess) {
            setApiData(res?.data || []);
            setFilteredData(res?.data || []);
            setSummaryData(res?.stats || null);
            setIsFocused(true);
        }
    };

    const getDealError = (err) => {
        toast.error(err?.response?.data?.msg || "Error fetching deals");
    };

    const {
        mutate: getDealListMutate,
        isLoading,
        isRefetching,
        error
    } = useMutation(fetchDealList, {
        onSuccess: getDealSuccess,
        onError: getDealError,
    });

    const refreshDeals = () => {
        getDealListMutate({ searchQuery, filterType, startDate, endDate });
    };


    useEffect(() => {
        //getDealListMutate({ searchQuery, filterType });
        refreshDeals();
    }, []);

    const dealTabs = [
        { key: "1", label: "Active", count: summaryData?.active || 0 },
        { key: "2", label: "Follow-ups", count: summaryData?.followup || 0 },
        { key: "3", label: "Booked", count: summaryData?.closed || 0 },
        { key: "5", label: "Active Lease", count: summaryData?.leased || 0 },
    ];

    const handleFilterChange = (values) => {
        const type = getFilterType(values.filterType);

        setFilterType(type);
        setSearchQuery(values.searchQuery);

        getDealListMutate({
            searchQuery: values.searchQuery,
            filterType: type,
            startDate,
            endDate,
        });
    };

    const handleClearFilter = () => {
        setFilterType("");
        setSearchQuery("");
        //getDealListMutate({ searchQuery: "", filterType: "" });
        refreshDeals();
    };


    //-----Edit Deal Basic--------------
    const editDealBasicFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/deal/edit/basic`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const editDealBasicSuccess = (data) => {
        setIsEditBasicInfo(false);
        //getDealListMutate({ searchQuery, filterType });
        refreshDeals();
        toast.success(data?.data?.msg || "Success");
    };

    const editDealBasicError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editDealBasicLoading, mutate: editDealBasicMutate } =
        useMutation(editDealBasicFunction, {
            onSuccess: editDealBasicSuccess,
            onError: editDealBasicError,
        });

    //-----Edit Deal--------------
    const editDealFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/deal/edit`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const editDealSuccess = (data) => {
        setIsEditDeal(false);
        //getDealListMutate({ searchQuery, filterType });
        refreshDeals();
        toast.success(data?.data?.msg || "Success");
    };

    const editDealError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editDealLoading, mutate: editDealMutate } =
        useMutation(editDealFunction, {
            onSuccess: editDealSuccess,
            onError: editDealError,
        });


    const getDealsByTab = (tab, deals = []) => {
        switch (tab) {
            case "1":
                return deals.filter(
                    (deal) => [1, 2, 3].includes(deal.status)
                );

            case "2":
                return deals.filter(
                    (deal) =>
                        !!deal.followUpDate &&
                        ![4, 5, 6, 7, 8].includes(deal.status)
                );

            case "3":
                return deals.filter((deal) => deal.status === 4);

            case "4":
                return deals.filter((deal) =>
                    [6, 7].includes(deal.status)
                );

            case "5":
                return deals.filter((deal) => deal.status === 5);

            default:
                return deals;
        }
    };

    // This useEffect only runs when activeTab changes AND no filter is applied
    useEffect(() => {
        if (!apiData || isFilterApplied) return;
        setFilteredData(getDealsByTab(activeTab, apiData));
    }, [activeTab, apiData, isFilterApplied]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setSelectedId(null);
        if (isFilterApplied) {
            setIsFilterApplied(false);
            setActiveFilter(null);
        }
        setFilteredData(getDealsByTab(tab, apiData));
    };

    const handleApplyFilter = (filterValue, filterLabel, filterType) => {
        let filtered = [...apiData];
        let effectiveTab = activeTab;

        if (filterType === "Status") {
            filtered = apiData.filter(deal => deal.status === filterLabel);

            if (filterLabel === 4) {
                effectiveTab = "3";
            } else if (filterLabel === 5) {
                effectiveTab = "4";
            } else {
                effectiveTab = "1";
            }
        } else if (filterType === "Property Type") {
            filtered = apiData.filter(deal =>
                deal.propertyInterest?.toLowerCase().includes(filterLabel.toLowerCase())
            );
            effectiveTab = "1";
        } else if (filterType === "Locality") {
            filtered = apiData.filter(deal =>
                deal.locationId === parseInt(filterValue.replace('LOC_', ''))
            );
            effectiveTab = "1";
        }

        setFilteredData(filtered);
        setActiveFilter({ value: filterValue, label: filterLabel, type: filterType });
        setIsFilterApplied(true);
        setActiveTab(effectiveTab);
        setIsFilterOpen(false);
    };

    const handleClearFilters = () => {
        setIsFilterApplied(false);
        setActiveFilter(null);
        setFilteredData(getDealsByTab(activeTab, apiData));
    };

    const handleDealClose = () => {
        setIsEditDeal(false);
    }

    const handleEditInfoClose = () => {
        setIsEditBasicInfo(false);
    }

    return (
        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    Deals
                    <Underline />
                </BoxTitle>
            </BoxHead>

            <SideModal
                isOpen={isFilterOpen}
                onClose={() => setIsFilterOpen(false)}
            >
                <FilterModal
                    onApplyFilter={handleApplyFilter}
                    handleClose={() => setIsFilterOpen(false)}
                    currentFilter={activeFilter}
                    handleClearFilters={handleClearFilters}
                />
            </SideModal>

            <SideModal
                isOpen={isEditDeal}
                onClose={() => setIsEditDeal(false)}
            >
                <EditDeal
                    selectedData={selectedData}
                    handleClose={handleDealClose}
                    editDealLoading={editDealLoading}
                    editDealMutate={editDealMutate}
                />
            </SideModal>

            <SideModal
                isOpen={isEditBasicInfo}
                onClose={() => setIsEditBasicInfo(false)}
            >
                <EditBasicInfo
                    selectedData={selectedData}
                    handleClose={handleEditInfoClose}
                    editDealBasicLoading={editDealBasicLoading}
                    editDealBasicMutate={editDealBasicMutate}
                />
            </SideModal>

            <SideModal
                isOpen={isViewNotes}
                onClose={() => setIsViewNotes(false)}
            >
                <Notes
                    isViewNotes={isViewNotes}
                    setIsViewNotes={setIsViewNotes}
                    selectedData={selectedData}
                    getDealListMutate={refreshDeals}
                />
            </SideModal>

            <FloorTabs>
                {dealTabs.map((tab) => (
                    <FloorTab
                        key={tab.key}
                        onClick={() => handleTabChange(tab.key)}
                        $active={activeTab === tab.key && !isFilterApplied}
                    >
                        {tab.label} ({tab.count})
                    </FloorTab>
                ))}
            </FloorTabs>

            {activeTab === "1" && (
                <>
                    {!isFocused && <SummarySkeletonLoading count={4} />}
                    {isFocused && summaryData && (
                        <SummaryCards
                            summaryData={summaryData}
                            setSelectedId={setSelectedId}
                            selectedId={selectedId}
                        />
                    )}
                </>
            )
            }

            <FilterTableWrapper>
                <FilterWrapper>
                    <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">

                        <SearchFilterBox
                            options={searchOptions}
                            handleFilterChange={handleFilterChange}
                            handleClearFilters={handleClearFilter}
                        />

                        <DateRange
                            submitHandler={(values) => {
                                const formattedStart = moment(values.startDate).format("YYYY-MM-DD");
                                const formattedEnd = moment(values.endDate).format("YYYY-MM-DD");
                                setStartDate(formattedStart);
                                setEndDate(formattedEnd);
                                getDealListMutate({
                                    searchQuery,
                                    filterType,
                                    startDate: formattedStart,
                                    endDate: formattedEnd,
                                });
                            }}
                            defaultLabel={`${moment(startDate).format("DD MMM yyyy")} - ${moment(endDate).format("DD MMM yyyy")}`}
                        />
                    </div>
                    {/* <div className="flex gap-2 justify-end items-center"></div> */}
                </FilterWrapper>

                {filteredData && !isLoading && (
                    <TableWrapper>
                        <Table
                            apiData={filteredData}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            activeTab={activeTab}
                            setIsEditDeal={setIsEditDeal}
                            setIsEditBasicInfo={setIsEditBasicInfo}
                            setIsViewNotes={setIsViewNotes}
                        />
                        {(!apiData || filteredData.length === 0) && <NotFoundModel />}
                    </TableWrapper>
                )}
            </FilterTableWrapper>
            {error && !isLoading && <NotFoundModel />}
            {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
    );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
const FloorTab = tw.button`
  ${(p) =>
        p.$active
            ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
            : " text-gray-700 "} 
   px-5 py-3 cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
export default Deal;